import { Injectable } from '@angular/core';
import { AutomationInterface } from '@vendasta/automata';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AccountGroupCreatedTrigger, StartCampaignAction } from '../component-loader/constants';
import { customAccountDataKey } from '../components/filters/definitions/auxiliary-data-filter/data-keys';
import { CurrentAutomationService } from '@galaxy/automata/shared';

export interface WorkflowWarning {
  translationKey: string;
  helpArticleLink: string;
  highlightStepId: string;
}

@Injectable({ providedIn: 'root' })
export class WorkflowWarningCalculatorService {
  //This should only be accessed directly via the error handler service
  workflowWarnings$: Observable<WorkflowWarning[]> = this.currentAutomationService.automation$.pipe(
    map(WorkflowWarningCalculatorService.calculateWarning),
  );

  constructor(private readonly currentAutomationService: CurrentAutomationService) {}

  static calculateWarning(automation: AutomationInterface): WorkflowWarning[] {
    const warnings = [];
    if (!automation) {
      return warnings;
    }
    const triggerDefinition = automation.triggerStep?.taskDefinitionId;
    const firstActionIdInTheWorkflow =
      automation.triggerStep?.choices?.rules?.length > 0
        ? automation.triggerStep.choices.rules[0].next
        : automation.triggerStep?.choices?.defaultNextStep;

    if (triggerDefinition === AccountGroupCreatedTrigger) {
      const firstAction = automation.workflow?.find((w) => w.id === firstActionIdInTheWorkflow);
      if (firstAction?.taskDefinitionId === StartCampaignAction) {
        warnings.push({
          translationKey: 'AUTOMATIONS.WARNINGS.START_CAMPAIGN_AFTER_ACCOUNT_CREATED',
          helpArticleLink: 'https://support.vendasta.com/hc/en-us/articles/4406958730007',
          highlightStepId: firstAction.id,
        });
      }

      if (!!automation.triggerFilters && JSON.stringify(automation.triggerFilters).includes(customAccountDataKey)) {
        warnings.push({
          translationKey: 'AUTOMATIONS.WARNINGS.CUSTOM_DATA_IN_TRIGGER',
          highlightStepId: automation.triggerStep?.id,
        });
      }
    }
    return warnings;
  }
}
